export function getViewPort() {
  if (document.compatMode === 'BackCompat') { // 浏览器嗅探，混杂模式
    return {
      width: document.body.clientWidth,
      height: document.body.clientHeight
    }
  } else {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    }
  }
}

// 截取数组
export function sliceArrayByOrder(arr, len) {
  var newArr = []
  var array = arr.reverse()
  var s = parseInt(array.length / len)
  var n = 0
  for (var i = 1; i <= s; i++) {
    var star = (i - 1) * len
    newArr[n++] = array.slice(star, star + len).reverse()
  }
  var y = array.length - s * len
  if (y > 0) {
    newArr[n++] = array.slice(s * len).reverse()
  }
  return newArr
}

// 字典转数组
export function dictionaryToArray(dict) {
  var array = []
  for (var k in dict) {
    array.push({
      key: k,
      val: dict[k]
    })
  }

  return array
}
// 定位
export function loadLocation(completion) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(location) {
      completion({
        latitude: location.coords.latitude,
        longitude: location.coords.longitude
      }, true)
    }, function() {
      completion({
        latitude: 37.09024,
        longitude: -95.712891
      }, false)
    }, {
      enableHighAccuracy: false,
      timeout: 3000
    })
  } else {
    completion({
      latitude: 37.09024,
      longitude: -95.712891
    }, false)
  }
}

// 获取参数
export function query(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 监听手势
export function listenGesture(ElementID, completion) {
  var element = document.getElementById(ElementID)
  var startX, startY, moveEndX, moveEndY, X, Y
  element.addEventListener('touchstart', function(e) {
    e.preventDefault()
    startX = e.touches[0].pageX
    startY = e.touches[0].pageY
  }, false)

  element.addEventListener('touchend', function(e) {
    e.preventDefault()
    moveEndX = e.changedTouches[0].pageX
    moveEndY = e.changedTouches[0].pageY
    X = moveEndX - startX
    Y = moveEndY - startY

    if (Math.abs(X) > Math.abs(Y) && X > 0) {
      completion('right')
    } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
      completion('left')
    } else if (Math.abs(Y) > Math.abs(X) && Y > 0) {
      completion('down')
    } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
      completion('up')
    } else {}
  })
}



// WEBPACK FOOTER //
// ./src/common/tool/Tools.js